import * as React from 'react';

function SvgAppIconVirtualBrands(props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 15 14"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      {...props}
    >
      <path d="M10.754 2.8a2.8 2.8 0 11-5.6 0 2.8 2.8 0 015.6 0zM6.555 10.8a2.8 2.8 0 11-5.6 0 2.8 2.8 0 015.6 0zM14.956 10.8a2.8 2.8 0 11-5.601 0 2.8 2.8 0 015.6 0z" />
    </svg>
  );
}

const ForwardRef = React.forwardRef(SvgAppIconVirtualBrands);
export default ForwardRef;
